import { TextValidator, ValidatorComponentProps } from 'react-material-ui-form-validator';

interface StandardTextValidatorProps extends ValidatorComponentProps {
    shrink?: boolean
}

export const StandardTextValidator = (params: StandardTextValidatorProps) => {
    return (
        <TextValidator 
            {...params}
            value={params.value || ""}
            InputLabelProps={{ shrink: params.shrink || (!!params.value || params.type === "date" || params.type === "file") }}
        />
    );
}
